import { PatchCostQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCost/patchCostQuery.type';
import { patchCostFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCost/patchCostQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchCostQueryOptions = () =>
  useMutation({
    mutationKey: ['patch-cost'],
    mutationFn: (params: PatchCostQueryParamsType) => patchCostFunction(params),
  });
